<template lang="html">
  <RowContent
    :model="model"
    :fullName="[candidate.name, candidate.surname].join(' ')"
  />
</template>

<script>
import RowContent from './RowContent.vue'

export default {
  name: 'process-responses-row',

  props: {
    model: Object
  },

  components: {
    RowContent
  },

  computed: {
    candidate () {
      return this.model.candidate
    }
  }
}
</script>
